import React from 'react';
import './MainContentAreaAll.css';
import { AgGridColumn, AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
function TechSkillCompo(props){
//      const listElements = props.skillList.map((skill) =>
//       <Skills key={skill.Skill}  data={skill} />
//   );
    return(
       <div className="ExperienceMainLayout">
         <h1 className="MainLabel">TechnicalSkills</h1>
         <br/>
         <div className="ag-theme-alpine GridLayot">
            <AgGridReact
                rowData={props.skillList}>
                <AgGridColumn field="Skill"></AgGridColumn>
                <AgGridColumn field="ExperienceInyear"></AgGridColumn>
                <AgGridColumn field="proficiency"></AgGridColumn>
                <AgGridColumn field="LastTimeUsed"></AgGridColumn>
            </AgGridReact>
        </div>
         <br/>
         {/* <table>
             <thead>
                 <th>Skill</th>
                 <th>ExperienceInyear</th>
                 <th>proficiency Out Of 10</th>
                 <th>Last-Used</th>
             </thead>
              {listElements}
             {/* <tr>
                 <td>C#</td>
                 <td>6</td>
                 <td>8</td>
                 <td>2021</td>
             </tr>
             <tr>
                 <td>C#</td>
                 <td>6</td>
                 <td>8</td>
                 <td>2021</td>
             </tr> 
         </table> */}
       </div>

    )
}


export default TechSkillCompo